// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NptT","left":"styles_left__pPkNz"};